<template>
  <Input
    ref="input"
    v-model="input"
    :placeholder="placeholder"
    :style="inputStyle"
    :disabled="disabled"
    :readonly="readonly"
    :size="size"
    @on-keydown="keyEvent"
    @on-blur="keyBlur"
  />
</template>
<script>
import { trim, timeout } from '@/common/js/utils'
const keys = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110, 190, 8, 13, 37, 38, 39, 40, 46]
export default {
  name: 'input-number-plus',
  props: {
    value: {
      type: [Number, String]
    },
    width: {
      type: [Number, String]
    },
    placeholder: {
      type: String
    },
    min: {
      type: Number
    },
    max: {
      type: Number,
      default: 10
    },
    maxNum: {
      type: Number
    },
    step: {
      type: Number
    },
    precision: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    allowNull: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        val = val.includes('.') ? parseFloat(val) : this.allowNull && !val ? null : Number(val)
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    visiable() {
      return Boolean(typeof this.value === 'number')
    },
    inputStyle() {
      const styleWidth = typeof this.width === 'number' ? `${this.width}px` : this.width
      return {
        width: styleWidth
      }
    }
  },
  methods: {
    // 动态词 键盘监听
    keyEvent(e) {
      const input = this.$refs.input && this.$refs.input.$refs.input
      let { _value, selectionStart, selectionEnd } = input
      if (selectionStart !== selectionEnd) return
      if (typeof _value !== 'string') _value = String(_value)
      const float = _value.includes('.')

      // 限制输入范围
      if (!keys.includes(e.keyCode)) window.event.returnValue = false
      else if (([110, 190].includes(e.keyCode) && this.precision === 0) || ([110, 190].includes(e.keyCode) && float)) {
        window.event.returnValue = false
      } else if (![8, 46, 37, 39].includes(e.keyCode) && float) {
        const [inter, floater] = _value.split('.')
        const lenInt = inter.length
        const lenFloat = floater.length
        const lastIndex = _value.lastIndexOf('.')
        if (selectionStart > lastIndex && lenFloat >= this.precision) window.event.returnValue = false // 输入小数位且小数位满
        else if (selectionStart <= lastIndex && lenInt >= this.max) {
          window.event.returnValue = false
          this.$Message.warning('超过了输入上限')
        }
      } else if (![8, 46, 37, 39, 110, 190].includes(e.keyCode) && _value.length >= this.max) {
        window.event.returnValue = false
        this.$Message.warning('超过了输入上限')
      } else if (e.shiftKey && e.keyCode === 190) {
        window.event.returnValue = false
      }
    },
    keyBlur() {
      const input = this.$refs.input && this.$refs.input.$refs.input
      let { _value } = input
      if (trim(_value) === '') return
      if (typeof _value === 'string') _value = Number(_value)
      this.$emit('on-blur', _value)
      if (this.min > _value) {
        this.$Message.warning('超过了输入最小值限制')
        this.$emit('input', this.min)
      } else if (this.maxNum < _value) {
        this.$Message.warning('超过了输入最大值限制')
        this.$emit('input', this.maxNum)
      } else {
        const val = isNaN(_value) ? this.min : String(_value)
        this.$emit('input', val)
        timeout(0).then(() => {
          this.$emit('input', Number(val))
        })
      }
    },
    focus() {
      // this.$refs.input.focus()
    }
  }
}
</script>
